<template>
  <div>
    <div @click="moduleShow=''" class="navbar_box">
      <div class="navbar_x">
        <div style="display: flex; align-items: center">
          <div>
            <img
              style="width: 100px; height: 100px"
              src="../assets/logo.png"
              alt=""
            />
          </div>
          <div
            style="
              color: #000;
              margin-left: 30px;
            "
          >
            <div style="font-size: 40px;">广东省电子信息行业协会</div>
            <div style="font-size: 16px;">Guangdong Electronics and Information Industry Association</div>
            <div style="font-size: 14px;display: flex;align-items: center;justify-content: space-between;">
              <span>全省先进社会组织</span>
              <span>AAAAA级行业协会</span>
            </div>
          </div>
        </div>
       <div>
          <div style="width: 300px;height: 40px;background-color: #fff;display: flex;align-items: center;justify-content: space-between;padding: 0 12px;">
            <div>
              <input
                 @keyup.enter="searchClick"
                placeholder="请输入关键词"
                v-model="search">
              </input>
            </div>
            <img @click="searchClick" style="width: 24px;height: 24px;cursor: pointer;" src="../assets/sh.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="navbar_list" @click="moduleShow=''" style="position: relative;">
      <div class="list_box">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="[{ active: item.id === id }]"
          @click="jump(item.id)"
          @mouseenter="mouseOver(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
      <div v-if="moduleShow" @mouseleave="moduleShow=''" style="position: absolute;padding: 30px; background-color: #fff;width: 1000px;z-index: 999;left: 50%;transform: translate(-50%, 0);border-radius: 0 0 10px 10px;">
        <div style="display: flex;flex-wrap: wrap;">
          <!-- 关于协会 -->
          <div @click="jumpDD(1, index, item.id)" v-if="moduleShow==1" v-for="(item, index) in gyxhArr" :key="index" style="cursor: pointer;display: flex;flex-direction: column;align-items: center;width: 160px;height: 90px;margin-bottom: 12px;">
            <img v-if="item.image" style="width: 40px;height: 40px;" :src="item.image" alt="">
            <div style="text-align: center;margin-top: 12px;">{{ item.name }}</div>
          </div>
          <!-- 资讯中心 -->
          <div @click="jumpDD(2, index, item.id)" v-if="moduleShow==2" v-for="(item, index) in zxzxArr" :key="index" style="cursor: pointer;display: flex;flex-direction: column;align-items: center;width: 160px;height: 90px;margin-bottom: 12px;">
            <img v-if="item.image" style="width: 40px;height: 40px;" :src="item.image" alt="">
            <div style="text-align: center;margin-top: 12px;">{{ item.name }}</div>
          </div>
          <!-- 协会活动 -->
          <div @click="jumpDD(3, index, item.id)" v-if="moduleShow==3" v-for="(item, index) in zhhdArr" :key="index" style="cursor: pointer;display: flex;flex-direction: column;align-items: center;width: 160px;height: 90px;margin-bottom: 12px;">
            <img v-if="item.image" style="width: 40px;height: 40px;" :src="item.image" alt="">
            <div style="text-align: center;margin-top: 12px;">{{ item.name }}</div>
          </div>
          <!-- 服务平台 -->
          <div @click="jumpDD(4, index, item.id)" v-if="moduleShow==4" v-for="(item, index) in fwptArr" :key="index" style="cursor: pointer;display: flex;flex-direction: column;align-items: center;width: 160px;height: 90px;margin-bottom: 12px;">
            <img v-if="item.image" style="width: 40px;height: 40px;" :src="item.image" alt="">
            <div style="text-align: center;margin-top: 12px;">{{ item.name }}</div>
          </div>
          <!--  会员之窗 -->
          <div @click="jumpDD(5, index, item.id)" v-if="moduleShow==5" v-for="(item, index) in hyzcArr" :key="index" style="cursor: pointer;display: flex;flex-direction: column;align-items: center;width: 160px;height: 90px;margin-bottom: 12px;">
            <img v-if="item.image" style="width: 40px;height: 40px;" :src="item.image" alt="">
            <div style="text-align: center;margin-top: 12px;">{{ item.name }}</div>
          </div>
          <!--  党建强会 -->
          <div @click="jumpDD(6, index, item.id)" v-if="moduleShow==6" v-for="(item, index) in djqhArr" :key="index" style="cursor: pointer;display: flex;flex-direction: column;align-items: center;width: 160px;height: 90px;margin-bottom: 12px;">
            <img v-if="item.image" style="width: 40px;height: 40px;" :src="item.image" alt="">
            <div style="text-align: center;margin-top: 12px;">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNav } from "@/request/api";
export default {
  data() {
    return {
      moduleShow: "",
      search: "",
      gyxhArr: [
      { name: "协会简介", id: 0, url: require("../assets/a1.png") },
      { name: "协会章程", id: 1, url: require("../assets/a2.png") },
      { name: "组织架构", id: 2, url: require("../assets/a3.png") },
      { name: "管理制度", id: 3, url: require("../assets/a4.png") },
      { name: "专家专委会", id: 4, url: require("../assets/a5.png") },
      { name: "协会宣传片", id: 5, url: require("../assets/a6.png") },
      { name: "协会专家库", id: 6, url: require("../assets/a7.png") },
      { name: "党建引领", id: 7, url: require("../assets/a8.png") },
      { name: "联系我们", id: 8, url: require("../assets/a9.png") },
      { name: "分支机构", id: 9, url: require("../assets/a15.png") },
      { name: "协会专家库", id: 10, url: require("../assets/a16.png") }
      ],
      zxzxArr: [
      { name: "协会动态", id: 0, url: require("../assets/a10.png") },
      { name: "通知公告", id: 1, url: require("../assets/a11.png") },
      { name: "行业动态", id: 2, url: require("../assets/a12.png") },
      { name: "政策法规", id: 3, url: require("../assets/a13.png") },
      { name: "公平贸易", id: 4, url: require("../assets/a14.png") },
      ],
      zhhdArr: [
      { name: "活动专题", id: 0, url: require("../assets/a15.png") },
      { name: "展会信息", id: 1, url: require("../assets/a16.png") },
      { name: "会员代表大会", id: 2, url: require("../assets/a17.png") },
      ],
      fwptArr: [
      { name: "服务平台", id: 0, url: require("../assets/a15.png") },
      { name: "服务平台", id: 1, url: require("../assets/a16.png") },
      { name: "服务平台", id: 2, url: require("../assets/a17.png") },
      { name: "服务平台", id: 3, url: require("../assets/a15.png") },
      { name: "服务平台", id: 4, url: require("../assets/a16.png") },
      { name: "服务平台", id: 5, url: require("../assets/a17.png") },
      { name: "服务平台", id: 6, url: require("../assets/a15.png") },
      { name: "服务平台", id: 7, url: require("../assets/a16.png") },
      { name: "服务平台", id: 8, url: require("../assets/a17.png") },
      { name: "服务平台", id: 9, url: require("../assets/a15.png") },
      { name: "服务平台", id: 10, url: require("../assets/a16.png") },
      ],
      hyzcArr: [
      { name: "会长单位", id: 0, url: require("../assets/b1.png") },
      { name: "副会长单位", id: 1, url: require("../assets/b2.png") },
      { name: "理事单位", id: 2, url: require("../assets/b3.png") },
      { name: "监事单位", id: 3, url: require("../assets/b4.png") },
      { name: "会员单位", id: 4, url: require("../assets/b5.png") },
      { name: "会员动态", id: 5, url: require("../assets/b6.png") },
      { name: "会员查询", id: 6, url: require("../assets/b7.png") },
      ],
      djqhArr: [
      { name: "党建动态", id: 0, url: require("../assets/b8.png") },
      { name: "党建文件", id: 1, url: require("../assets/b9.png") },
      ],
      list: [
        { name: "首页", id: 0 },
        { name: '关于协会', id: 1 },
        { name: '资讯中心', id: 2 },
        { name: '协会活动', id: 3 },
        { name: "服务平台", id: 4 },
        { name: "会员之窗", id: 5 },
        { name: "党建强会", id: 6 },
      ],
      id: "",
      token: sessionStorage.getItem("token"),
      navList: [],
      routerData: {}
    };
  },
  watch: {
    '$route': {
      handler: function (to, from) {
        this.token = sessionStorage.getItem("token")
        if (this.$route.path === "/home") {
          this.id = 0;
        } else if (this.$route.path === "/aboutTheAssociation") {
          this.id = 1;
        } else if (this.$route.path === "/informationCenter") {
          this.id = 2;
        } else if (this.$route.path === "/associationActivities") {
          this.id = 3;
        } else if (this.$route.path === "/career" || this.$route.path === '/careerList') {
          this.id = 4;
        } else if (this.$route.path === "/apply") {
          this.id = 5;
        } else if (this.$route.path === "/practiceTest") {
          this.id = 6;
        } else if (this.$route.path === "/career") {
          this.id = 7;
        }
        // 如果路由参数有所更新，比如参数id变化了
        console.log(to, from, '2222222222222')
        if (to.path==='/home'||from.path==='/home') {
          return
        } else {
          if (from.path==='/') {

          } else {
            if (to.query.id !== from.query.id) {
            // 这里可以执行数据加载或者其他逻辑
            console.log(this.routerData, '111')
            location.reload()
          }
          }

        }

      },
      // 设置为深度监听
      deep: true
    }
    // $route() {
    //   this.token = sessionStorage.getItem("token")
    //   if (this.$route.path === "/home") {
    //     this.id = 0;
    //   } else if (this.$route.path === "/aboutTheAssociation") {
    //     this.id = 1;
    //   } else if (this.$route.path === "/informationCenter") {
    //     this.id = 2;
    //   } else if (this.$route.path === "/associationActivities") {
    //     this.id = 3;
    //   } else if (this.$route.path === "/career" || this.$route.path === '/careerList') {
    //     this.id = 4;
    //   } else if (this.$route.path === "/apply") {
    //     this.id = 5;
    //   } else if (this.$route.path === "/practiceTest") {
    //     this.id = 6;
    //   } else if (this.$route.path === "/career") {
    //     this.id = 7;
    //   }
    // },
  },
  created() {
    setTimeout(() => {
      if (this.$route.query.search) {
        this.search = this.$route.query.search
      }
    }, 500)
    if (this.$route.path === "/home") {
        this.id = 0;
      } else if (this.$route.path === "/aboutTheAssociation") {
        this.id = 1;
      } else if (this.$route.path === "/informationCenter") {
        this.id = 2;
      } else if (this.$route.path === "/associationActivities") {
        this.id = 3;
      } else if (this.$route.path === "/career" || this.$route.path === '/careerList') {
        this.id = 4;
      } else if (this.$route.path === "/apply") {
        this.id = 5;
      } else if (this.$route.path === "/practiceTest") {
        this.id = 6;
      } else if (this.$route.path === "/career") {
        this.id = 7;
      }
    getNav().then(res => {
      console.log(res)
      this.navList = res.data
      this.hyzcArr = res.data.vip
      this.gyxhArr = res.data.about
      this.gyxhArr.push({
          name: "分支机构",
          id: 11,
          image: require("../assets/b4.png")
      })
      this.gyxhArr.push({
         name: "协会专家库",
         id: 12,
         image: require("../assets/a7.png")
      })
      this.djqhArr = res.data.dangjian
      this.fwptArr = res.data.service
      this.zxzxArr = res.data.news
      this.zhhdArr = res.data.activity

    })
  },
  methods: {
    searchClick() {
      if (this.search) {
        this.$router.push(`/search?search=${this.search}`)
        if (window.location.hash.indexOf('/search') != -1) {
          this.$router.go(0);
        }
      }
    },
    jumpDD(num, index, id) {
      this.routerData = {
        num: num,
        index: index,
        id: id,
      }
      if (num === 1) {
        this.$router.push(`/aboutTheAssociation?index=${index}&id=${id}`)
      } else if (num === 2) {
        this.$router.push(`/informationCenter?index=${index}&id=${id}`)
      } else if (num === 3) {
        this.$router.push(`/associationActivities?index=${index}&id=${id}`)
      } else if (num === 4) {
        this.$router.push(`/careerList?id=${id}`)
      } else if (num === 5) {
        this.$router.push(`/apply?index=${index}&id=${id}`)
      } else if (num === 6) {
        this.$router.push(`/practiceTest?index=${index}&id=${id}`)
      }
    },
    outLogin() {
      this.$confirm("确定退出登录?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "退出成功!",
          });
          sessionStorage.setItem("token", "");
          history.go(0)
        })
        .catch(() => {
          return;
        });
    },
    mouseOver(id) {
      this.moduleShow = id
    },
    jump(id) {
      if (id == 0) {
        this.$router.push("/home");
      } else if (id == 1) {
        this.$router.push('/aboutTheAssociation')
      } else if (id == 2) {
        this.$router.push('/informationCenter')
      } else if (id == 3) {
        this.$router.push('/associationActivities')
      } else if (id == 4) {
        this.$router.push("/career");
      } else if (id == 5) {
        this.$router.push("/apply");
      } else if (id == 6) {
        this.$router.push("/practiceTest");
      } else if (id == 7) {
        this.$router.push("/admin");
      }
      console.log(this.moduleShow)
      this.id = id;
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar_box {
  width: 100%;
  background-image: url('../assets/navbarbg.png');
    background-size: cover;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.16);
  .navbar_x {

    width: 1200px;
    padding: 40px 0;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.navbar_list {
  width: 100%;
  background-color: #98cffe;
  .list_box {
    width: 1000px;
    margin: 0 auto;
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    display: flex;
    > div {
      cursor: pointer;
      position: relative;
      padding: 16px 36px;
    }
    .active {
      background-color: #2595E8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue